// extracted by mini-css-extract-plugin
export default {"root":"XmJqDzGfoIknBGDOH_qx","editor":"NcZTT9jyaZ3otiA9FyVB"};